<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="admin-settings-associations-settings-title">
                {{ $t('admin.association_settings.title') }}
            </div>
        </div>
        <association-table @onAdd="onAdd" @onTableAction="onTableAction" ref="AssociationTable" />
        <a-drawer
            data-cy="association-drawer"
            :title="$t('admin.association_settings.view.title')"
            :width="625"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onClose"
        >
            <form-association
                ref="FormAssociation"
                :association="association"
                :association_id="association_id"
                :is_create="is_create"
                @onDrawerClose="onClose"
                @reloadTable="reload"
            >
                <template #actions>
                    <div data-cy="actions-list">
                        <a-dropdown :trigger="['click']" class="float-left" v-if="association.id">
                            <a-button @click="(e) => e.preventDefault()">
                                {{ $t('association.actions.actions') }}
                                <DownOutlined />
                            </a-button>
                            <template #overlay>
                                <a-menu @click="onActionButtonsForm">
                                    <a-menu-item key="remove" data-cy="actions-remove-association">
                                        {{ $t('association.actions.remove_association') }}
                                    </a-menu-item>
                                </a-menu>
                            </template>
                        </a-dropdown>
                    </div>
                </template>
            </form-association>
        </a-drawer>
        <modal-remove-association
            @formSubmit="onRemoveAssociation"
            :processing="processing"
            :association_code="association.association_code"
            ref="RemoveAssociationModal"
        />
    </div>
</template>

<script>
import AssociationTable from '@/components/tables/Associations.vue';
import FormAssociation from '@/components/forms/Association.vue';
import ModalRemoveAssociation from '@/components/modals/RemoveAssociation.vue';
import { DownOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        AssociationTable,
        FormAssociation,
        ModalRemoveAssociation,
        DownOutlined,
    },
    data() {
        return {
            drawer_visible: false,
            association: {},
            association_id: null,
            is_create: false,
            processing: false,
        };
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        onTableAction(data) {
            switch (data.key) {
                case 'edit':
                    this.$http
                        .get('/api/associations/' + data.id)
                        .then((response) => {
                            this.association = {
                                ...response.data.data,
                                password_include_numbers:
                                    response.data.data.password_include_numbers === 1 ? true : false,
                                password_include_symbols:
                                    response.data.data.password_include_symbols === 1 ? true : false,
                                is_ip_address_routing: response.data.data.is_ip_address_routing === 1 ? true : false,
                                is_hide_claim_description:
                                    response.data.data.is_hide_claim_description === 1 ? true : false,
                                is_enable_deactivation_process:
                                    response.data.data.is_enable_deactivation_process == 1 ? true : false,
                                is_enforce_filename_restriction:
                                    response.data.data.is_enforce_filename_restriction == 1 ? true : false,
                                is_allow_company_admin_assignment:
                                    response.data.data.is_allow_company_admin_assignment == 1 ? true : false,
                                is_module_cia_enabled: response.data.data.is_module_cia_enabled === 1 ? true : false,
                                is_module_claimsvault_enabled:
                                    response.data.data.is_module_claimsvault_enabled === 1 ? true : false,
                                is_module_covervault_enabled:
                                    response.data.data.is_module_covervault_enabled === 1 ? true : false,
                                restrict_cover_dashboard_data:
                                    response.data.data.restrict_cover_dashboard_data === 1 ? true : false,
                                import_date_limit:
                                    response.data.data.import_date_limit === null
                                        ? this.$dayjs()
                                        : this.$dayjs(response.data.data.import_date_limit),
                                user_session_timeout: process.env.MIX_SESSION_LIFETIME,
                                admin_email:
                                    response.data.data.admin_email === null || response.data.data.admin_email === ''
                                        ? []
                                        : _.split(response.data.data.admin_email, ','),
                                default_landing_page:
                                    response.data.data.default_landing_page === null
                                        ? 'claimsvault_dashboard'
                                        : response.data.data.default_landing_page,
                                is_tfa_enabled: response.data.data.is_tfa_enabled === 1 ? true : false,
                                allow_dp_companies_to_add_api_users:
                                    response.data.data.allow_dp_companies_to_add_api_users === 1 ? true : false,
                                enable_advanced_claims_analytics:
                                    response.data.data.enable_advanced_claims_analytics === 1 ? true : false,
                                enable_advanced_cover_analytics:
                                    response.data.data.enable_advanced_cover_analytics === 1 ? true : false,
                                is_claim_auto_removal_enabled:
                                    response.data.data.is_claim_auto_removal_enabled === 1 ? true : false,
                                is_cover_auto_removal_enabled:
                                    response.data.data.is_cover_auto_removal_enabled === 1 ? true : false,
                            };
                            this.association_id = data.id;

                            this.is_create = false;
                            this.drawer_visible = true;
                        })
                        .catch((error) => {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVAF01' }),
                            });
                        });
                    break;
            }
        },
        onActionButtonsForm(event) {
            switch (event.key) {
                case 'remove':
                    this.confirmAssociationRemoval();
                    break;
            }
        },
        confirmAssociationRemoval() {
            this.$refs.RemoveAssociationModal.showModal();
        },
        onRemoveAssociation() {
            if (this.processing) {
                return false;
            }

            this.processing = true;

            this.$http
                .post('/api/admin/association/' + this.association.id + '/remove')
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$refs.RemoveAssociationModal.hideModal();
                        this.onClose({ action: 'update' });

                        this.$notification.success({
                            message: response.data.message,
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.404'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVAR01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        onAdd() {
            this.association = {
                name: null,
                association_code: null,
                decline_days: 0,
                import_date_limit: this.$dayjs(),
                association_logo: null,
                email_address: '',
                admin_email: [],
                user_session_timeout: process.env.MIX_SESSION_LIFETIME,
                password_expire_days: 30,
                max_login_attempts: 3,
                attempt_duration: 5,
                lockout_time: 30,
                password_history_count: 1,
                password_minimum_length: 8,
                password_age: 1,
                password_include_numbers: false,
                password_include_symbols: false,
                is_ip_address_routing: false,
                is_hide_claim_description: false,
                is_enable_deactivation_process: false,
                is_allow_company_admin_assignment: false,
                days_until_next_deactivation: 120,
                api_max_limit: 10,
                api_name_min_length: 50,
                search_name_min_length: 6,
                search_year_limit: 0,
                search_max_limit: 100,
                is_module_cia_enabled: false,
                is_module_claimsvault_enabled: false,
                is_module_covervault_enabled: false,
                default_landing_page: '',
                is_tfa_enabled: false,
                allow_dp_companies_to_add_api_users: false,
                max_immediate_cover_processing_limit: 0,
                enable_advanced_claims_analytics: true,
                enable_advanced_cover_analytics: true,
                public_cover_search_tagline: '',
                public_cover_search_min_search_value: 2,
                claims_detail_layout: 'default',
                data_retention_limit_claim: 0,
                is_claim_auto_removal_enabled: false,
                data_retention_limit_cover: 0,
                is_cover_auto_removal_enabled: false,
            };
            this.is_create = true;
            this.drawer_visible = true;
        },
        onClose(data) {
            this.drawer_visible = false;

            if (data.action == 'create') {
                this.$refs.AssociationTable.fetch({
                    page: 1,
                    sortField: 'created_at',
                    sortOrder: 'descend',
                });
            } else if (data.action == 'update') {
                this.$refs.AssociationTable.reload();
            }
        },
        reload() {
            this.$refs.AssociationTable.reload();
        },
    },
};
</script>
